import type { BinaryImage, GrayImage } from "./types";

export interface ThresholdOptions {
  /** Threshold value 0..255. */
  threshold: number;
  /**
   * When false (default), foreground = pixels brighter than the threshold
   * (useful for isolating light tiles on a dark background).
   * When true, foreground = pixels darker than or equal to the threshold
   * (useful for isolating dark pips on a light tile).
   */
  invert?: boolean;
}

/**
 * Convert a grayscale image to a binary mask using a fixed threshold.
 */
export function threshold(
  image: GrayImage,
  { threshold: t, invert = false }: ThresholdOptions,
): BinaryImage {
  const data = new Uint8Array(image.data.length);
  for (let i = 0; i < data.length; i++) {
    const bright = image.data[i] > t;
    data[i] = (invert ? !bright : bright) ? 1 : 0;
  }
  return { width: image.width, height: image.height, data };
}
